import axios from 'axios'
import AuthToken from '@/auth/auth-token'

class Resync {
  constructor() {
    const base = axios.create({
      baseURL: process.env.VUE_APP_BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    this.tprs = base
  }

  async scheduleFullResync(payload) {
    await AuthToken.setAuth(this.tprs)
    return this.tprs({
      url: '/tpr/schedule_resync',
      method: 'POST',
      data: payload
    })
  }

  async deleteScheduledResync(syncID) {
    await AuthToken.setAuth(this.tprs)
    return this.tprs({
      url: `/tpr/schedule_resync/${syncID}`,
      method: 'DELETE'
    })
  }

  async getScheduledResyncs(payload, limit, offset) {
    await AuthToken.setAuth(this.tprs)
    return this.tprs({
      url: '/tpr/schedule_resync_search',
      method: 'POST',
      data: payload,
      params: {
        limit: limit,
        offset: offset
      }
    })
  }
}

export default new Resync()